<template>
  <UserForm mode="add" />
</template>

<script>
import UserForm from '@/components/form/UserForm.vue';
import {mapGetters} from "vuex";

export default {
  components: {
    UserForm,
  },
  created() {
    if (this.user.role !== 'admin')
      this.$router.push('/');
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  }
}
</script>